import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface NewsDetailProps {
  idx: string;
  title: string;
  url: string;
  content: string;
  news_date: string;
}

const NewsDetailpage: React.FC = () => {
  const { idx } = useParams<{ idx: string }>();
  const [newsDetailItem, setNewsDetailItem] = useState<NewsDetailProps | null>(
    null
  );
  const navigate = useNavigate();
  const didShowMainPage = () => {
    navigate('/')
  }

  useEffect(() => {
    const body = { idx, version: "V2" };
    axios
      .post<NewsDetailProps>("/specificNews", body)
      .then((response) => {
        setNewsDetailItem(response.data);
      })
      .catch((err) => console.log(err));
  }, []);

function fixHtmlImgPaths(html: string): string {
  let result = html.replace(
    /src=(["'])\/img\//g,
    `src=$1https://www.mpaper.co.kr:8443/img/`
  );
  result = result.replace(
    /src=(["'])\.\/img\//g,
    `src=$1https://www.mpaper.co.kr:8443/img/`
  );
  result = result.replace(
    /src=(["'])\/upload\//g,
    `src=$1https://www.mpaper.co.kr:8443/upload/`
  );

  return result;
}

  return (
    <div className="news-detail-content block text-center pt-20 font-sans">
      <article>
        <div className="news-detail-area-title block max-w-2xl items-center mx-auto">
          <div className="news-detail-wrap-sub-info inline-block leading-5 pt-10">
            <span className="news-detail-wrap-sub-title font-normal text-gray-900 text-lg">
              뉴스
            </span>
            <span className="news-detail-wrap-sub-date  font-normal text-gray-800 text-lg">
              {" "}
              | 2025년 07월 16일
            </span>
          </div>
          <h3 className="news-detail-wrap-main-title font-bold text-black text-[42px] leading-tight pt-4">
            {newsDetailItem?.title}
          </h3>
        </div>
        <div
          className="max-w-screen-tablet items-center mx-auto px-4 pb-8 text-left"
          dangerouslySetInnerHTML={{
            __html: fixHtmlImgPaths(newsDetailItem?.content || ""),
          }}
        />
      <div className="pb-10 pt-10">
        <button onClick={didShowMainPage} className="news-detail-back-button-cotainer bg-[#EEEEEE] w-48 h-12 rounded-lg focus:bg-gray-300">
          <span className="font-semibold text-xl text-black">메인화면</span>
        </button>
      </div>

      </article>
    </div>
  );
};

export default NewsDetailpage;
